// extracted by mini-css-extract-plugin
export default {"header":"HomePageHeader_header__tbJK7","Icon":"HomePageHeader_Icon__g+ndN","text":"HomePageHeader_text__n3mra"};